// extracted by mini-css-extract-plugin
export default {"Box":"issue-type-renderer-module__Box__i1brwK6","Token":"issue-type-renderer-module__Token__kRu2crT"};